import css from './OurMission.module.css';
import BackgroundLines from '../BackgroundLines/BackgroundLines';
import { FormattedMessage } from '../../../util/reactIntl';
import { ReactComponent as Checkmark } from '../../../assets/icons/checkmark-24x24.svg';
import NamedLink from '../../NamedLink/NamedLink';

const guaranteeBlocks = [
  {
    id: 'gblock-1',
    title: 'OurMission.Box1.Title',
    text: 'OurMission.Box1.Text',
  },
  {
    id: 'gblock-2',
    title: 'OurMission.Box2.Title',
    text: 'OurMission.Box2.Text',
  },
  {
    id: 'gblock-3',
    title: 'OurMission.Box3.Title',
    text: 'OurMission.Box3.Text',
  },
];

const OurMision = () => {
  return (
    <div className={css.wrapper} data-topbar-theme="dark">
      <div className={css.mainWrap}>
        {/* <BackgroundLines isDark /> */}

        <div className={css.container}>
          <header className={css.heading}>
            <h3 className={css.headingTitle}>
              <FormattedMessage
                id="OurMission.Title"
                values={{
                  span: chunks => (
                    <span className={css.highlight}>
                      {chunks}
                    </span>
                  ),
                }}
              />
            </h3>

            <p className={css.headingDescription}>
              <FormattedMessage id="OurMission.Description" />
            </p>
          </header>

          <div className={css.guarantee} id="guarantee">
            <h3 className={css.guaranteeTitle}>
              <FormattedMessage
                id="OurMission.Subtitle"
                values={{
                  span: chunks => (
                    <span className={css.highlight}>
                      {chunks}
                    </span>
                  ),
                }}
              />
            </h3>

            <div className={css.guaranteeBlocks}>
              {guaranteeBlocks.map(item => (
                <div
                  className={css.guaranteeBlock}
                  key={item.id}
                >
                  <h4 className={css.guaranteeBlockTitle}>
                    <span className={css.guaranteeBlockIcon}>
                      <Checkmark />
                    </span>

                    <FormattedMessage id={item.title} />
                  </h4>

                  <p className={css.guaranteeBlockText}>
                    <FormattedMessage
                      id={item.text}
                      values={{
                        link: chunks => (
                          <NamedLink
                            name="HelpCenterPage"
                            to={{
                              search:
                                item.id === 'gblock-2'
                                  ? '?tab=verification-security&question=verification-1'
                                  : '?tab=shipping-returns&question=buyer-protection',
                            }}
                            className={css.customLink2}
                          >
                            {chunks}
                          </NamedLink>
                        ),

                        link2: chunks => (
                          <NamedLink
                            name="HelpCenterPage"
                            to={{
                              search:
                                '?tab=shipping-returns&question=buyer-protection',
                            }}
                            className={css.customLink2}
                          >
                            {chunks}
                          </NamedLink>
                        ),
                      }}
                    />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMision;